import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core';

/**
 * Linear gradient matching Embold full-color donut: yellow (top) → green → teal (bottom).
 * SplashAnimation root uses rotate(90deg); in pre-rotate SVG space, screen vertical maps to +x,
 * so the gradient runs left-to-right in SVG user space.
 */
function SplashGradientDefs({ id, size }) {
  const { palette } = useTheme();

  const cy = size / 2;
  return (
    <defs>
      <linearGradient id={id} x1="0" y1={cy} x2={size} y2={cy} gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor={palette.splashScreen.offset0} />
        <stop offset="42%" stopColor={palette.splashScreen.offset42} />
        <stop offset="68%" stopColor={palette.splashScreen.offset68} />
        <stop offset="100%" stopColor={palette.splashScreen.offset100} />
      </linearGradient>
    </defs>
  );
}

export default SplashGradientDefs;

SplashGradientDefs.propTypes = {
  id: PropTypes.string.isRequired,
  size: PropTypes.number.isRequired,
};
